import {configureStore} from '@reduxjs/toolkit';

import {
    ApiAction,
    CALL_API,
    DOWNLOAD_FILE,
    Types,
    UPLOAD_FILE,
    handleErrors,
    responseToPayload,
} from '@pb/middleware-api';

import {api, handleErrors as handle} from '../middleware';
import {rootReducer} from '../reducer';

import type {ApiDispatchForToolkit} from '../openapi/types';
import type {Middleware} from '@reduxjs/toolkit';

export type RootState = ReturnType<typeof rootReducer>;
export type PreloadedState = Partial<RootState>;
export type AppDispatch = typeof store.dispatch;
type ApiActionType = ApiAction<Types, Record<string, never>>;

const isApiAction = (action: ApiAction<Types, unknown> | unknown): action is ApiActionType => {
    const isObject = !!action && typeof action === 'object';

    return isObject && (CALL_API in action || DOWNLOAD_FILE in action || UPLOAD_FILE in action);
};

export const setupStore = (preloadedState?: PreloadedState) => {

    const oktaMiddleware: Middleware = () => next => action => {
        if (isApiAction(action)) {
            const payload = action[CALL_API] ?? action[UPLOAD_FILE] ?? action[DOWNLOAD_FILE];
            const oktaToken = localStorage.getItem('okta-token-storage') ?? '';
            const token = JSON.parse(oktaToken)?.idToken;
            const idToken = token?.idToken;

            if (payload && idToken) {
                payload.headers = {...payload.headers, Authorization: `Bearer ${idToken}`};
            }
        }

        return next(action);
    };

    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: getDefaultMiddleware => getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            oktaMiddleware,
            api as Middleware<ApiDispatchForToolkit, RootState>,
            handleErrors(handle) as unknown as Middleware,
            responseToPayload as Middleware,
        ),
        devTools: {name: 'UD Event Design Tool UI'},
    });
};

export const store = setupStore();
